var _rect, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgR1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 112,
    height: 112,
    viewBox: "0 0 112 112",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 112,
    height: 112,
    rx: 16,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60 40.2L56 44",
    stroke: "#0034A3",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M42.2004 47.9994L36.4004 46.3994",
    stroke: "#0034A3",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M44.0002 56L40.2002 60",
    stroke: "#0034A3",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M46.3994 36.4004L47.9994 42.2004",
    stroke: "#0034A3",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M50.0733 51.3793C49.9958 51.1966 49.9746 50.9949 50.0124 50.8001C50.0503 50.6053 50.1455 50.4262 50.2859 50.2859C50.4262 50.1455 50.6053 50.0503 50.8001 50.0124C50.9949 49.9746 51.1966 49.9958 51.3793 50.0733L73.3793 59.0733C73.5751 59.1536 73.7404 59.294 73.8513 59.4742C73.9623 59.6545 74.0132 59.8652 73.9968 60.0762C73.9803 60.2872 73.8973 60.4876 73.7598 60.6484C73.6222 60.8093 73.4372 60.9223 73.2313 60.9713L64.5333 63.0533C64.1743 63.1391 63.8459 63.3226 63.5847 63.5834C63.3235 63.8443 63.1396 64.1724 63.0533 64.5313L60.9733 73.2313C60.9249 73.4379 60.8119 73.6237 60.6509 73.7619C60.4898 73.9 60.289 73.9834 60.0774 73.9999C59.8659 74.0163 59.6546 73.9651 59.4741 73.8535C59.2935 73.742 59.1532 73.5759 59.0733 73.3793L50.0733 51.3793Z",
    stroke: "#0034A3",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgR1);
export default __webpack_public_path__ + "static/media/r1.6771ad62f0c816acf3d80e2c5e23d83e.svg";
export { ForwardRef as ReactComponent };